import { decrypt } from '../secure';

export const CURRENT_ENV = process.env.REACT_APP_ENVIRONMENT || 'STAGING-QA';
export const IS_GOOGLE_SPOT_ENV = [
  'GOOGLE-SPOT-QA',
  'GOOGLE-SPOT-PROD',
  'GOOGLE-SPOT-PREPROD',
].includes(CURRENT_ENV);

export const getBaseUrl = () => {
  switch (CURRENT_ENV) {
    case 'PRODUCTION':
      return 'https://portal.fibe.in/';
    case 'STAGING':
      return 'https://portal-v4.fibe.in/';
    case 'STAGING-PREPROD':
      return 'https://portal-qa.fibe.in/';
    case 'STAGING-QA':
      return 'https://portal-qa.fibe.in/';
    case 'STAGING-TEST':
      return 'https://portal-test.fibe.in/';
    case 'STAGING-UAT':
      return 'https://portal-uat.fibe.in/';
    case 'GOOGLE-SPOT-QA':
      return 'https://spotdev.fibe.in/';
    case 'GOOGLE-SPOT-PROD':
      return 'https://spot.fibe.in/';
    case 'GOOGLE-SPOT-PREPROD':
      return 'https://spot-preprod.fibe.in/';
    default:
      return 'https://portal-qa.fibe.in/';
  }
};

export const getOldBaseUrl = () => {
  switch (CURRENT_ENV) {
    case 'PRODUCTION':
      return 'https://portal-v2.fibe.in';
    case 'GOOGLE-SPOT-PROD':
      return 'https://portal-v2.fibe.in';
    case 'GOOGLE-SPOT-PREPROD':
      return 'https://portal-v2.fibe.in';
    case 'STAGING':
      return 'https://portal-v2.fibe.in';
    case 'STAGING-PREPROD':
      return 'https://portal-qa.earlysalary.com';
    case 'STAGING-QA':
      return 'https://portal-qa.earlysalary.com';
    case 'STAGING-TEST':
      return 'https://portal-qa.earlysalary.com';
    case 'GOOGLE-SPOT-QA':
      return 'https://portal-qa.earlysalary.com';
    case 'STAGING-UAT':
      return 'https://portal-qa.earlysalary.com';
    default:
      return 'https://portal-qa.earlysalary.com';
  }
};

export const getCIRurl = () => {
  switch (CURRENT_ENV) {
    case 'PRODUCTION':
      return 'https://creditscore.fibe.in/cir-landing?src=web&sso=';
    case 'STAGING':
      return 'https://creditscore.fibe.in/cir-landing?src=web&sso=';
    case 'GOOGLE-SPOT-PROD':
      return 'https://creditscore.fibe.in/cir-landing?src=web&sso=';
    case 'GOOGLE-SPOT-PREPROD':
      return 'https://creditscore.fibe.in/cir-landing?src=web&sso=';
    case 'STAGING-PREPROD':
      return 'https://creditscore-qa-reroute.fibe.in/cir-landing?src=web&sso=';
    case 'STAGING-QA':
      return 'https://creditscore-qa-reroute.fibe.in/cir-landing?src=web&sso=';
    case 'STAGING-TEST':
      return 'https://creditscore-qa-reroute.fibe.in/cir-landing?src=web&sso=';
    case 'GOOGLE-SPOT-QA':
      return 'https://creditscore-qa-reroute.fibe.in/cir-landing?src=web&sso=';
    case 'STAGING-UAT':
      return 'hhttps://creditscore-qa-reroute.fibe.in/cir-landing?src=web&sso=';
    default:
      return 'https://creditscore-qa-reroute.fibe.in/cir-landing?src=web&sso=';
  }
};

export const getCIRBaseUrl = () => {
  switch (CURRENT_ENV) {
    case 'PRODUCTION':
      return 'https://creditscore.fibe.in';
    case 'GOOGLE-SPOT-PROD':
      return 'https://creditscore.fibe.in';
    case 'GOOGLE-SPOT-PREPROD':
      return 'https://creditscore.fibe.in';
    case 'GOOGLE-SPOT-QA':
      return 'https://creditscore.fibe.in';
    case 'STAGING':
      return 'https://creditscore.fibe.in';
    case 'STAGING-PREPROD':
      return 'https://creditscore-qa-reroute.fibe.in';
    case 'STAGING-QA':
      return 'https://creditscore-qa-reroute.fibe.in';
    case 'STAGING-TEST':
      return 'https://creditscore-qa-reroute.fibe.in';
    case 'STAGING-UAT':
      return 'https://creditscore-qa-reroute.fibe.in';
    default:
      return 'https://creditscore-qa-reroute.fibe.in';
  }
};

export const getWebviewsUrl = () => {
  switch (CURRENT_ENV) {
    case 'PRODUCTION':
      return 'https://portal-ec2.fibe.in/fibe-landing?section=disbursement&src=web&sso=';
    case 'GOOGLE-SPOT-PROD':
      return 'https://portal-ec2.fibe.in/fibe-landing?section=disbursement&src=web&sso=';
    case 'GOOGLE-SPOT-PREPROD':
      return 'https://portal-ec2.fibe.in/fibe-landing?section=disbursement&src=web&sso=';

    case 'STAGING':
      return 'https://portal-ec2.fibe.in/fibe-landing?section=disbursement&src=web&sso=';
    case 'STAGING-PREPROD':
      return 'https://portal-qa.fibe.in/fibe-landing?section=disbursement&src=web&sso=';
    case 'STAGING-QA':
      return 'https://portal-qa.fibe.in/fibe-landing?section=disbursement&src=web&sso=';
    case 'STAGING-TEST':
      return 'https://portal-qa.fibe.in/fibe-landing?section=disbursement&src=web&sso=';
    case 'GOOGLE-SPOT-QA':
      return 'https://portal-qa.fibe.in/fibe-landing?section=disbursement&src=web&sso=';
    case 'STAGING-UAT':
      return 'https://portal-uat.fibe.in/fibe-landing?section=disbursement&src=web&sso=';
    default:
      return 'https://portal-qa.fibe.in/fibe-landing?section=disbursement&src=web&sso=';
  }
};

/**
 * Returns the DigiLocker portal URL based on the current environment.
 */
export const getDigilockerPortalUrl = () => {
  return process.env.REACT_APP_DL_KYC_PORTAL_URL || '';
};

/**
 * Returns the decrypted DigiLocker Client ID.
 */
export const getDigilockerClientId = () => {
  return decrypt(null, process.env.REACT_APP_DL_KYC_CLIENT_ID, true).replace(
    /"|'|`/g,
    ``
  );
};

/**
 * Returns the decrypted DigiLocker Client Secret Key.
 */
export const getDigilockerClientSecretKey = () => {
  return decrypt(
    null,
    process.env.REACT_APP_DL_KYC_CLIENT_SECRET,
    true
  ).replace(/"|'|`/g, ``);
};

/**
 * Envelope encryption master switch (per-request AES session key, RSA-OAEP
 * wrapped in the `uuid_wp` header). `"true"` enables it; anything else keeps the
 * legacy customerId-based AES. Setting it to `"false"` and redeploying is the
 * complete rollback — see `utils/secure/README.md`.
 * @returns {boolean}
 */
export const isEnvelopeEncryptionEnabled = () => {
  if (forceEncryption) return false;
  return process.env.REACT_APP_ENVELOPE_ENCRYPTION_ENABLED === 'true';
};

// Given by @Nikhil Rathi
export const getXApiKeyByEnv = () => {
  return decrypt(null, process.env.REACT_APP_ENCRYPTED_X_API_KEY, true).replace(
    /"|'|`/g,
    ``
  );
};

// Set at runtime when getcertificate fails (see utils/secure/fetch-certificate.js).
// While true, the envelope scheme is off for the rest of this page load, so API
// calls go out on the legacy scheme instead of being blocked. In memory only: a
// reload, or `resetCertificateFetchState` on logout/login, tries envelope again.
let forceEncryption = false;

/**
 * Forces the envelope scheme off (true) or hands control back to the env var (false).
 * @param {boolean} value
 */
export const setForceEncryption = (value) => {
  forceEncryption = !!value;
};

/** @returns {boolean} true while a getcertificate failure has forced envelope off */
export const isForceEncryption = () => forceEncryption;
